/**
 * Access token'ın ömrü — SÜRESİ DOLMADAN yenilemek için.
 *
 * Yenileme bugüne kadar yalnızca 401 yanıtına bağlıydı. Sunucu kimlik zorlamasını
 * kapalı çalıştırdığında (Auth:Enforce=false, bugünkü kurulumların çoğu) süresi dolmuş
 * token 401 ÜRETMİYOR: istek başarıyla geçiyor ama SUNUCU TARAFINDA KİMLİKSİZ oluyor.
 * Sonuç sessiz ve kafa karıştırıcı — ekran verisi geliyor, rol yetkileri gelmiyor;
 * kullanıcı yetkisi olduğu hâlde Yeni/Düzenle/Sil düğmelerini göremiyor (canlıda
 * ölçüldü: taze token ile roleObject dolu, süresi dolmuş token ile null).
 */
const SKEW_SECONDS = 60;

/** JWT'nin `exp` alanı (saniye); çözülemezse null. */
export function tokenExpiry(token: string | null | undefined): number | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = parts[1]!.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '='));
    const exp = (JSON.parse(json) as { exp?: unknown }).exp;
    return typeof exp === 'number' ? exp : null;
  } catch {
    return null;
  }
}

/**
 * Token yenilenmeli mi? `exp` okunamıyorsa HAYIR döner: biçimini bilmediğimiz bir
 * token yüzünden her istekte yenileme denemek, çalışan oturumu gereksiz yere riske atar.
 */
export function isTokenExpiring(token: string | null | undefined, nowMs = Date.now()): boolean {
  const exp = tokenExpiry(token);
  if (exp === null) return false;
  return exp - SKEW_SECONDS <= Math.floor(nowMs / 1000);
}
